import { useContext } from 'react';
import useSessionStorage, { chartItemProps } from './useSessionStorage';
import ChartContext from '../context/ChartContext';

const useChart = () => {
  const {getSessionStorage} = useSessionStorage();
  const { setChartTotal } = useContext(ChartContext);  
  let totalQuantity = 0;
  let totalPrice = 0;
  const updateChartQuantity = () => {
    const chartList: Array<chartItemProps> = getSessionStorage();
    if(chartList.length) {
      chartList.forEach(element => {
        totalQuantity += element.quantity;
        totalPrice += element.itemPrice * element.quantity;
      });
    }
    setChartTotal(() => ({
      priceTotal: totalPrice,
      itemsTotal: totalQuantity,
    }));
  }
  
  return updateChartQuantity;
}

export default useChart;